import React, { useEffect } from 'react';
export function useSeoArticleScript(script, id, templateName) {
  useEffect(function () {
    if (typeof window !== 'undefined') {
      if (templateName === 'Article' || templateName === 'Article Listicle Page') {
        var inlineScript = document.createElement('script');
        inlineScript.setAttribute('id', id);
        inlineScript.setAttribute('type', 'application/ld+json');
        inlineScript.innerHTML = script;
        document.body.append(inlineScript);
        return function () {
          inlineScript.remove();
        };
      }
    }
  }, []);
}
export var renderRTListSchema = function renderRTListSchema(list) {
  var schemaMap = JSON.stringify(list.map(function (item, index) {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: item
    };
  }));
  var scriptContent = "{\"@context\": \"https://schema.org\",\"@type\": \"ItemList\",\"itemListElement\": ".concat(schemaMap, "}");
  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: scriptContent
    }
  });
};
export var getListsTexts = function getListsTexts(dom) {
  if (!dom) return [];
  var rtLists = dom.querySelectorAll('ul, ol');
  var listValues = [];
  rtLists.forEach(function (list) {
    var listItemsForCurrentList = [];
    list.querySelectorAll('> li').forEach(function (li) {
      listItemsForCurrentList.push(li.text);
    });
    listValues.push(listItemsForCurrentList);
  });
  return listValues;
};